var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.82531 0 5.0625 1.76281 5.0625 3.9375C5.0625 5.69562 7.63594 8.9 8.62187 10.0631C8.82156 10.2987 9.17875 10.2987 9.37813 10.0631C10.3641 8.9 12.9375 5.69562 12.9375 3.9375C12.9375 1.76281 11.1747 0 9 0ZM9 5.25C8.275 5.25 7.6875 4.6625 7.6875 3.9375C7.6875 3.2125 8.275 2.625 9 2.625C9.725 2.625 10.3125 3.2125 10.3125 3.9375C10.3125 4.6625 9.725 5.25 9 5.25ZM0.62875 6.74844C0.443191 6.82267 0.284123 6.95079 0.172056 7.11628C0.0599888 7.28176 6.13476e-05 7.47702 0 7.67688L0 15.4994C0 15.8531 0.357188 16.095 0.685625 15.9637L5 14V6.71625C4.72375 6.21687 4.49781 5.73063 4.33594 5.26562L0.62875 6.74844ZM9 11.2397C8.56031 11.2397 8.14438 11.0466 7.85906 10.7097C7.24469 9.98469 6.59125 9.15906 6 8.31219V13.9997L12 15.9997V8.3125C11.4087 9.15906 10.7556 9.985 10.1409 10.71C9.85563 11.0466 9.43969 11.2397 9 11.2397ZM17.3144 5.03625L13 7V16L17.3713 14.2516C17.5568 14.1774 17.7159 14.0493 17.828 13.8838C17.9401 13.7183 18 13.523 18 13.3231V5.50063C18 5.14688 17.6428 4.905 17.3144 5.03625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.25bd9be28420e723040d796fa6fe40cc.svg";
export { ForwardRef as ReactComponent };